import { render, staticRenderFns } from "./PersonalNavigationItemModel.vue?vue&type=template&id=34cc6871&"
import script from "./PersonalNavigationItemModel.vue?vue&type=script&lang=js&"
export * from "./PersonalNavigationItemModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports